var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "@mui/material";
import { BODY_TEXT_COLOR } from "../utils/chartConstants";
var PieLegendList = function (_a) {
    var items = _a.items, isMobile = _a.isMobile, valueFormatter = _a.valueFormatter;
    return (_jsx(Box, __assign({ sx: {
            display: "grid",
            gridTemplateColumns: isMobile
                ? "minmax(0, 1fr)"
                : "repeat(2, minmax(0, 1fr))",
            columnGap: isMobile ? 1 : 2,
            rowGap: 1,
            mt: 1.5,
        } }, { children: items.map(function (item) { return (_jsxs(Box, __assign({ sx: {
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 1.25,
                minWidth: 0,
                py: 0.25,
            } }, { children: [_jsxs(Box, __assign({ sx: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 0.9,
                        minWidth: 0,
                        flex: 1,
                    } }, { children: [_jsx(Box, { sx: {
                                width: 10,
                                height: 10,
                                borderRadius: "999px",
                                background: item.color,
                                mt: "5px",
                                flexShrink: 0,
                            } }), _jsx(Box, __assign({ sx: {
                                fontFamily: "Montserrat, sans-serif",
                                fontSize: isMobile ? "0.73rem" : "0.74rem",
                                fontWeight: 500,
                                color: BODY_TEXT_COLOR,
                                lineHeight: 1.35,
                                wordBreak: "break-word",
                                minWidth: 0,
                            } }, { children: item.name }))] })), _jsx(Box, __assign({ sx: {
                        fontFamily: "Montserrat, sans-serif",
                        fontSize: isMobile ? "0.78rem" : "0.8rem",
                        fontWeight: 700,
                        color: BODY_TEXT_COLOR,
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                        textAlign: "right",
                        pt: "1px",
                    } }, { children: valueFormatter(item.value) }))] }), item.name)); }) })));
};
export default PieLegendList;
